import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Edit = function Edit(props) {
  useDeprecatedComponentWarning({
    component: 'Edit'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M442 150l-39 39-80-80 39-39c8-8 22-8 30 0l50 50c8 8 8 22 0 30zM64 368l236-236 80 80-236 236H64v-80z"
  }));
};

Edit.displayName = 'Edit';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Edit.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Edit;